export * from "./AllNewsPage";
